import { type ComponentProps, useMemo } from 'react';

export interface RichContentRecord {
  v1: {
    content?: string;
  };
}

export interface RichContentProps extends ComponentProps<'span'> {
  record: { richContent: RichContentRecord };
}

export function RichContent({ record, ...spanProps }: RichContentProps) {
  const content = record.richContent.v1.content;

  const renderedContent = useMemo(() => {
    if (!content) return null;

    const tagRegex = /{@}\[([^\]]*)\]\((\d+)\)/g;
    const parts: React.ReactNode[] = [];
    let lastIndex = 0;
    let match: RegExpExecArray | null;

    while ((match = tagRegex.exec(content)) !== null) {
      const [fullMatch, name, id] = match;

      if (match.index > lastIndex) {
        // Add the text between the last match + current match into the parts
        // This is the non-tag user content
        parts.push(content.slice(lastIndex, match.index));
      }

      parts.push(<strong key={`${id}-${match.index}`}>@{name}</strong>);

      lastIndex = match.index + fullMatch.length;
    }

    if (lastIndex < content.length) {
      // Add any remaining text left-over after the final tag
      // If the text contains no tags, this will be the entire text content
      parts.push(content.slice(lastIndex));
    }

    return parts;
  }, [content]);

  if (!renderedContent) return null;

  return <span {...spanProps}>{renderedContent}</span>;
}
